import React from 'react';
import css from './CustomLandingPage.module.css';
import { LayoutSingleColumn, Page } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { connect } from 'react-redux';
import { compose } from 'redux';
import ListingsSection from './sections/ListingsSection/ListingsSection';
import AdsSection from './sections/AdsSection/AdsSection';
import HeroSection from './sections/HeroSection/HeroSection';
import StripSection from './sections/StripSection/StripSection';
import HeroSectionScanwow from './sections/HeroSectionScanwow/HeroSectionScanwow';
import BecomeCreatorSection from './sections/BecomeCreatorSection/BecomeCreatorSection';
import VideoSection from './sections/VideoSection/VideoSection';
import DiscoverSection from './sections/DiscoverSection/DiscoverSection';
import WhySection from './sections/WhySection/WhySection';
import SectionTools from './sections/SectionTools/SectionTools';
import SectionLogos from './sections/SectionLogos/SectionLogos';
import WhoSection from './sections/WhoSection/WhoSection';
import BlogSection from './sections/BlogSection/BlogSection';
import StepsSection from './sections/StepsSection/StepsSection';
import EmailSection from './sections/EmailSection/EmailSection';
import PopupBanner from './components/PopupBanner/PopupBanner';
import ComingSoonSection from './sections/ComingSoonSection/ComingSoonSection';
import LiveScansSection from './sections/LiveScansSection/LiveScansSection';

const CustomLandingPageComponent = (props) => {
  const { currentUser, location } = props;
  return (
    <Page title={'ScanWow'} description={'ScanWow'} scrollingDisabled={false}>
      <LayoutSingleColumn
        rootClassName={css.pageRoot}
        topbar={<TopbarContainer currentPage="LandingPage" />}
        footer={<FooterContainer />}
      >
        {/* <ComingSoonSection /> */}

        {/* // new sections, to be uncommented */}
        <HeroSectionScanwow location={location} />
        <BecomeCreatorSection />
        <VideoSection />
        <DiscoverSection />
        <StepsSection />
        <WhySection />
        <LiveScansSection />
        <BlogSection />
        <SectionLogos />
        <WhoSection />
        <EmailSection />
        <SectionTools />
        <PopupBanner />

        {/* 
        // OLD SECTIONS - to be removed
        <ListingsSection />
        <AdsSection /> */}
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = (state) => {
  const { currentUser } = state.user;

  return {
    currentUser,
  };
};

const mapDispatchToProps = (dispatch) => ({});

const CustomLandingPage = compose(connect(mapStateToProps, mapDispatchToProps))(
  CustomLandingPageComponent
);

export default CustomLandingPage;
